import moment from 'moment';
import { Intl } from '@erecruit/core';
import { TIME_PARAM_FORMAT } from '../../../../constants';

export const calculateEstimatedSpend = (
  targetBillRate: number,
  numberOfPositions: number,
  hours: number,
  durationInDays: number,
) => {
  return (
    targetBillRate &&
    numberOfPositions &&
    targetBillRate * numberOfPositions * hours * durationInDays
  );
};

export const getHours = (
  startTime?: moment.Moment,
  endTime?: moment.Moment,
) => {
  return startTime && endTime
    ? moment(endTime, TIME_PARAM_FORMAT).diff(
        moment(startTime, TIME_PARAM_FORMAT),
        'hours',
        true,
      )
    : 8;
};

export const currencySymbol: Function = (intl: Intl.InjectedIntl): string =>
  intl.formatMessage({
    id: messageIds.vms.currencySymbol,
  });

export const currencySuffix: Function = (intl: Intl.InjectedIntl): string =>
  intl.formatMessage({
    id: messageIds.vms.currencySuffix,
  });
